import React, { useState } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Drawer,
  List,
  ListItem,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import IMAGES_FANS from '../../assets/IMAGES_FANS.svg';
import useIsMobile from '../shared/hooks/useIsMobile';
import {
  StyledHeaderBox,
  StyledLinksBox,
  StyledLink,
  StyledListItemText,
  StyledAppBar,
  StyledIconButton,
  StyledList,
} from './Header.styled';

const Header = () => {
  const isMobile = useIsMobile();
  const [drawerOpen, setDrawerOpen] = useState(false);

  const toggleDrawer = (open: boolean) => () => {
    setDrawerOpen(open);
  };

  return (
    <StyledAppBar position="static">
      <Toolbar>
        <img src={IMAGES_FANS} alt="Logo" width="60px" />
        <StyledHeaderBox>
          <Typography
            variant={isMobile ? 'h6' : 'h4'}
            component="h1"
            fontWeight="bold"
          >
            best-streaming-bundle
          </Typography>
          {isMobile ? (
            <>
              <StyledIconButton
                color="inherit"
                edge="end"
                onClick={toggleDrawer(true)}
              >
                <MenuIcon />
              </StyledIconButton>
              <Drawer
                anchor="right"
                open={drawerOpen}
                onClose={toggleDrawer(false)}
              >
                <StyledList>
                  <ListItem component="a" href="/">
                    <StyledListItemText primary="Home" />
                  </ListItem>
                  <ListItem component="a" href="/providerprices">
                    <StyledListItemText primary="Price Overview" />
                  </ListItem>
                  <ListItem component="a" href="/gamefinder">
                    <StyledListItemText primary="Game Finder" />
                  </ListItem>
                </StyledList>
              </Drawer>
            </>
          ) : (
            <StyledLinksBox>
              <StyledLink href="/">Home</StyledLink>
              <StyledLink href="/providerprices">Price Overview</StyledLink>
              <StyledLink href="/gamefinder">Game Finder</StyledLink>
            </StyledLinksBox>
          )}
        </StyledHeaderBox>
      </Toolbar>
    </StyledAppBar>
  );
};

export default Header;
